"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("../../components/utils");
class ActivityTracker {
  static init(callback, timePeriod) {
    ActivityTracker.prolongCallback = (0, _utils.debounce)(callback, timePeriod * 1000);
    ActivityTracker.events.forEach(name => {
      document.addEventListener(name, ActivityTracker.prolongCallback);
    });
    document.addEventListener('scroll', ActivityTracker.prolongCallback, true);
  }
  static clear() {
    ActivityTracker.events.forEach(name => {
      document.removeEventListener(name, ActivityTracker.prolongCallback);
    });
    document.removeEventListener('scroll', ActivityTracker.prolongCallback, true);
  }
}
ActivityTracker.events = ['mousedown', 'mousemove', 'keypress', 'touchstart'];
ActivityTracker.prolongCallback = null;
var _default = exports.default = ActivityTracker;